export const certificationConsideredExpiringMilliseconds = 1000 * 60 * 60 * 24 * 30;
